module.exports = __webpack_public_path__ + "img/default.8c2b4ec0.png";